<div class="tab_body">
    <!-- <div class="flex-end" *ngIf="dataSource?.length > 0">
        <button class="can" (click)="downloadCSV()" *ngIf="!isLoading">
            <mat-icon>cloud_download</mat-icon>
            Export CSV
        </button>
        <img [src]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
    </div> -->
    <fury-list>
        <fury-list-table>
            <table class="lead_list" [dataSource]="dataSource" mat-table>
                <form [formGroup]="leadSearchForm">             
                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                        <div class="search" (click)="searchData()">
                            <mat-icon>search</mat-icon>
                        </div>
                        <h3>
                            Actions
                        </h3>
                    </th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item (click)="navigateDetailsPage(row)">
                                <span>View</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="addedOn" sticky>
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="date" placeholder="Added On" style="visibility: hidden;"/>
                            <h3>
                                Added On
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{commonService.convertDate(element?.createdAt) | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="First Name" formControlName="firstName"/>
                            <h3>
                                First Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Last Name" formControlName="lastName"/>
                            <h3>
                                Last Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Email Address" formControlName="emailAddress"/>
                            <h3>
                                Email Address
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="mobileNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Mobile No" formControlName="mobileNumber" mask="0*"/>
                            <h3>
                                Mobile No
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.mobileNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="businessPhoneNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Business Phone Number" mask="0*" formControlName="businessPhoneNumber"/>
                            <h3>
                                Business Phone Number
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.businessPhoneNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="utmSource">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Utm Source" formControlName="utmSource"/>
                            <h3>
                               Utm Source
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.utmSource}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="leadSource">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Lead Source" formControlName="leadSource"/>
                            <h3>
                               Lead Source
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.leadSource}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Address" style="visibility: hidden;"/>
                            <h3>
                                Address
                            </h3>
                        </div>
                    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.streetAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="City" style="visibility: hidden;"/>
                            <h3>
                                City
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="State" style="visibility: hidden;"/>
                            <h3>
                                State
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.propertyAddress?.state}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="zipCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Zip Code" style="visibility: hidden;"/>
                            <h3>
                                Zip Code
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.streetAddress?.zip}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="resultCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Result Code" style="visibility: hidden;"/>
                            <h3>
                                Result Code
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.vanillaSoftData?.ResultCode}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ipAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Ip Address" style="visibility: hidden;"/>
                            <h3>
                                Ip Address
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.ipAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="internalUrl">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Internal Url" style="visibility: hidden;"/>
                            <h3>
                                Internal Url
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.internalUrl}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="trackingNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Tracking Number" style="visibility: hidden;"/>
                            <h3>
                                Tracking Number
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.trackingNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="duration">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Tracking Number" style="visibility: hidden;"/>
                            <h3>
                                Duration
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.duration}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="leadStatus">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Lead Status" style="visibility: hidden;"/>
                            <h3>
                                Lead Status
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.vanillaSoftData?.leadStatus}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="soldAmount">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Sold Amount" style="visibility: hidden;"/>
                            <h3>
                                Sold Amount
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{(element?.soldAmount || 0) | currency}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="resultCount" >
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div>
                                <input type="date" placeholder="Result code" style="visibility: hidden;"/>
                            </div>
                            <h3>
                                Result Count
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.vanillaSoftData?.resultCount}}
                    </td>
                </ng-container>
             
                <ng-container matColumnDef="isPostedToVanillaSoft">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>     
                            <div>
                                <input type="date" placeholder="Vanilla Soft Status" style="visibility: hidden;"/>
                            </div>
                            <h3>
                                Vanilla Soft Status
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon>{{element?.isPostedToVanillaSoft ? 'task_alt' : 'block'}}</mat-icon>
                    </td>
                </ng-container>
    
               
               <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </form>  
            </table>
            <div *ngIf="dataSource?.length === 0" style="padding: 10px 0; text-align:center;">
                No Leads found.
            </div>
        </fury-list-table>
    
    </fury-list>
</div>
